import ReactGA from "react-ga4";

const analytics = ReactGA;

analytics.initialize("G-37EPBNKCHG", {
  gtagOptions: { send_page_view: false },
});

export default analytics;
